<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" top="3vh" @close="close">
    <!-- 所属用户 -->
    <el-form  :rules="rules" ref="ruleForm"  :model="form" label-width="100px" >
      <el-form-item label="编号" prop="code">
        <el-input v-model.trim="form.code" ></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="name">
        <el-input v-model.trim="form.name" ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model.trim="form.phone" ></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <div v-for="(item,index) in form.address" :key="index" style="display: flex; align-items: center;margin-bottom: 8px;">
          <el-input  v-model.trim="item.text"  > </el-input>
          <el-button style="color: red;margin-left: 8px;" type="text" @click="del(index)">删除</el-button>
        </div>
        <el-button type="primary" @click="add()">添加新地址</el-button>
      </el-form-item>
      <el-form-item label="通关码" prop="idcode">
        <el-input v-model.trim="form.idcode" ></el-input>
      </el-form-item>
      <el-form-item label="邮编" prop="zipcode">
        <el-input v-model.trim="form.zipcode" ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    Monad_update, //新用户添加修改
    Monad_detail, //详情
  } from '@/api/new_user.js'

  export default {
    name: 'UserManagementEdit',
    data() {
      return {
        dialogFormVisible: false,
        form: {
          "code": "",  //编号
          "name": "", //用户名
          "idcode": "", //通关码
          "zipcode": "", //邮编
          "address": [
            {text:''},
          ], //地址
          "phone": "" //电话号
        },
        rules:{
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          code: [{ required: true, message: '请输入编号', trigger: 'blur' }],
          idcode: [{ required: true, message: '请输入通关码', trigger: 'blur' }],
          zipcode: [{ required: true, message: '请输入邮编', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入电话号', trigger: 'blur' }],
          address:{ validator:(rule, value, callback)=>{
            if (value.length>0) {
                  var ok = true
                  value.forEach((item,index)=>{
                    if(!item.text){
                      ok = false
                    }
                  })
                  if(ok){
                    callback();
                  }else{
                    callback(new Error('地址不能为空'));
                  }
            } else {
              callback(new Error('请添加地址'));
            }
          }, trigger: 'blur' ,required: true,}

        },

        title: '',
        listInfo: [],
        brandList: [],
      }
    },

    created() {},
    methods: {
      add(){
        this.form.address.push({text:''})
      },
      del(index){
        if(this.form.address.length<=1){
          this.$message({
            type:'warning',
            message:'最少需要一条地址'
          })
        }else{
          this.form.address.splice(index, 1);
        }
      },
      // 获取详情数据
      showEdit(row) {
        if(row){
          // 编辑
          this.title = '编辑用户'
          var data = {
            id:row.id
          }
          Monad_detail(data).then(res=>{
            var data = JSON.parse(JSON.stringify(res.data))
            var arr = []
            var arr2 = JSON.parse(res.data.address)
            if(arr2){
              arr2.forEach((item,index)=>{
                arr.push({text:item})
              })
            }
            data.address = arr
            this.form = data
            console.log(this.form)
            this.dialogFormVisible = true
          })
        }else{
          //新增用户
          this.title = '新增用户'
          this.dialogFormVisible = true
        }
      },

      // 点击关闭弹窗
      close() {
        this.dialogFormVisible = false
        this.form = {
          "code": "",  //编号
          "name": "", //用户名
          "idcode": "", //通关码
          "zipcode": "", //邮编
          "address": [
            {text:''}
          ], //地址
          "phone": "" //电话号
        }
      },
      // 点击提交更改
      save() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            var address = []
            this.form.address.forEach((item,index)=>{
              address.push(item.text)
            })
            var data = {
              "id": this.form.id?this.form.id:null, //id
              "code": this.form.code, //编号
              "name": this.form.name, //用户名
              "idcode": this.form.idcode, //通关码
              "zipcode": this.form.zipcode, //邮编
              "address": address.join('||'), //地址
              "phone": this.form.phone //电话号码
            }
            Monad_update(data).then(res=>{
              this.close()
              this.$emit('formChange' , true)
              this.$message({
                type:'success',
                message:'操作成功'
              })
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
    },
  }
</script>
<style scoped>
  .black {
    font-weight: bold;
    color: #000000;
  }

  .xinxi {
    border: 1px solid #dcdfe6;
    margin-bottom: 5px;
    padding: 10px;
    box-sizing: border-box;
  }
</style>
